import { PplPopoverTooltipComponent } from './popover-tooltip.component';
import { PplPopoverDirective } from '../popover/popover.directive';
import { Directive, HostListener, Input } from '@angular/core';
import type {
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef
} from '@angular/core';

@Directive({
  selector: '[pplPopover][pplPopoverTooltip]',
  standalone: false
})
export class PplTooltipDirective implements OnChanges, OnInit {

  @Input() pplPopoverTooltip: string | TemplateRef<any>;
  @Input() pplPopoverTooltipDirection: 'down' | 'up' = 'up';
  @Input() pplPopoverTooltipFollowMouse = false;
  @Input() pplPopoverTooltipType?: 'warning' | 'error';
  @Input() pplPopoverTooltipPreserveWhitespace = false;
  @Input() pplPopoverTooltipHoverPreserve = false;

  constructor(
    private popoverDirective: PplPopoverDirective
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pplPopoverTooltip && !changes.pplPopoverTooltip.firstChange) {
      this.setPopover();
    }
  }

  ngOnInit() {
    this.setPopover();
  }

  setPopover() {
    if (this.pplPopoverTooltip) {
      this.popoverDirective.pplPopoverDirection = this.pplPopoverTooltipFollowMouse
        ? 'down'
        : this.pplPopoverTooltipDirection;
      this.popoverDirective.pplPopoverEvent = this.pplPopoverTooltipFollowMouse
        ? null
        : !this.pplPopoverTooltipHoverPreserve ? 'hover' : 'hover-preserve';
      this.popoverDirective.pplPopoverComponent = PplPopoverTooltipComponent;
      this.setPopoverText();
    } else {
      this.popoverDirective.pplPopoverComponent = null;
      this.popoverDirective.pplPopoverComponentData = null;
      this.popoverDirective.setComponentData();
    }
  }

  setPopoverText(setData = false) {
    this.popoverDirective.pplPopoverComponentData = {
      type: this.pplPopoverTooltipType,
      text: this.pplPopoverTooltip,
      color: 'red',
      preserveWhitespace: this.pplPopoverTooltipPreserveWhitespace
    };

    if (setData) {
      this.popoverDirective.setComponentData();
    }
  }

  @HostListener('mousemove', ['$event'])
  onMoveErrorTooltip(event: MouseEvent) {
    if (!this.pplPopoverTooltipFollowMouse) {
      return;
    }

    if (!this.popoverDirective.pplPopoverDisabled) {
      this.updateTooltipPosition(event);
      this.popoverDirective.show();
    }
  }

  @HostListener('mouseleave')
  onHideErrorTooltip() {
    if (!this.pplPopoverTooltipFollowMouse) {
      return;
    }

    if (this.popoverDirective.isOpen) {
      this.popoverDirective.hide();
    }
  }

  private updateTooltipPosition(event: MouseEvent) {
    this.popoverDirective.pplPopoverAnchorRect = {
      left: event.pageX + DefaultMouseOffsetPx,
      right: event.pageX + DefaultMouseOffsetPx,
      top: event.pageY + DefaultMouseOffsetPx,
      bottom: event.pageY + DefaultMouseOffsetPx,
      height: 0,
      width: 0
    };
    this.popoverDirective.recalcPosition();
  }
}

const DefaultMouseOffsetPx = 5;
